export default __webpack_public_path__ + "static/media/image-3.007d0cf8.webp";